    //markup:
    // <div class="tabs">
    //     <ul class="tabs__navigation">
    //         <li class="tabs__tab">
    //             <a href="#tab1">Tab Title</a>
    //         </li>
    //         <li class="tabs__tab">
    //             <a href="#tab2">Tab Title</a>
    //         </li>
    //     </ul>
    //     <div class="tabs__panels">
    //         <div class="tabs__panel"></div>
    //         <div class="tabs__panel"></div>
    //     </div>
    // </div>

export default (($) => {

return function() {

    //VARIABLES
    var $tabsWrapper = $(this),
        $tabs = $tabsWrapper.find('.tabs__navigation').children('li'),
        $panels = $tabsWrapper.find('.tabs__panels').children('.tabs__panel'),
        hashtag = window.location.hash,
        panelId = window.location.hash.replace('#','');

    //FUNCTIONS
    var togglePanelFn = function( $this_hash, $this_tab, $this_panel ){
          if( !$this_tab.hasClass('tab--active') && !$this_panel.hasClass('panel--active') ){

              //Make other panel inactive
              $panels.removeClass('panel--active');
              $tabs.removeClass('tab--active');

              //activate this panel
              $this_panel.addClass('panel--active');
              $this_tab.addClass('tab--active');

              window.location.hash = $this_hash
          }
    };

    //TAB ANCHOR CLICKS
    $tabs.find('a').on('click', function(e){
        e.preventDefault();

        var this_hash = $(this).attr('href');
        var this_tab = $(this).parent();
        var this_panel = $panels.eq(this_tab.index());

        togglePanelFn(this_hash, this_tab, this_panel);
    });

    //PRESELECTED ACTIVE TAB (USE OF HASHTAGS)
    if( hashtag && $tabs.children('a[data-id="'+panelId+'"]').length>0 ){

        var selected_tab = $tabs.children('a[data-id="'+panelId+'"]').parent();
        var selected_panel = $panels.eq(selected_tab.index());

        togglePanelFn(hashtag, selected_tab, selected_panel);

    }
}

})(jQuery)
